import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';
import { AxiosRequestConfig } from 'axios';

export const getListAnnouncements = async (queryParams: AxiosRequestConfig) => {
  const config = {
    params: queryParams
  };

  const urlBuilder = createUrlBuilder(`/sentinel/system/notices`).toString();
  // @ts-ignore
  return await getRequest(LocateService, urlBuilder, config);
};
